<template>
  <v-container
    fluid
    fill-height
    dark
    class="message-container animated fadeInDown">
    <v-layout
      align-content-center
      text-center
      row>
      <v-flex xs12>
        <h1 class="text-h1 message-title">401</h1>
      </v-flex>
      <v-flex xs12>
        <h3 class="text-h5 font-weight-bold message-title">{{ $t("errors.network.401.type") }}</h3>
      </v-flex>
      <v-flex xs12>
        <h2 class="text-h6 message-title">{{ $t("errors.network.401.desc") }}</h2>
      </v-flex>
      <v-flex xs12>
        <p class="message-instruction">
          {{ $t("errors.network.401.instructions") }}
        </p>
      </v-flex>
      <v-flex xs12>
        <div class="sk-spinner sk-spinner-circle message-spinner">
          <div class="sk-circle1 sk-circle" />
          <div class="sk-circle2 sk-circle" />
          <div class="sk-circle3 sk-circle" />
          <div class="sk-circle4 sk-circle" />
          <div class="sk-circle5 sk-circle" />
          <div class="sk-circle6 sk-circle" />
          <div class="sk-circle7 sk-circle" />
          <div class="sk-circle8 sk-circle" />
          <div class="sk-circle9 sk-circle" />
          <div class="sk-circle10 sk-circle" />
          <div class="sk-circle11 sk-circle" />
          <div class="sk-circle12 sk-circle" />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Error401Module"
  , head: {
    title: function () {
      return {
        inner: this.$t("errors.network.401.type")
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    setTimeout(() => this.$router.push({ name: "SignIn" }), 4000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.message-container {
  background-color: #2f4050;
}
.message-title {
  margin-bottom: 10px;
  color: white;
}
.message-instruction {
  margin-bottom: 30px;
  color: #c4c4c4;
}
</style>



// WEBPACK FOOTER //
// src/views/error/401.vue